import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable, signal } from '@angular/core';
import { PaymentStatus, PaymentSummary, PaymentTableHistory, PaymentTablePending, ProformasResponse } from './utils-payments';
import { AppConfig, buildApiUrl } from '@app/app.config';
import { map, Observable } from 'rxjs';
import { formatPriceAr } from '../shipments/utils-shipments';
import { formatDate } from '@app/shared/components/utils';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {
  private http = inject(HttpClient);

  private listHistories = signal<PaymentTableHistory[] | null>(null);
  private listPending = signal<PaymentTablePending[] | null>(null);
  private countHistories = signal<number>(0);
  private countPending = signal<number>(0);
  
  listHistoriesPayments = computed(() => this.listHistories());
  listPendingPayments = computed(() => this.listPending());
  countHistoriesPayments = computed(() => this.countHistories());
  countPendingPayments = computed(() => this.countPending());

  getListPayments(): void {
    this.http.get<PaymentSummary>((buildApiUrl(AppConfig.getListPayment)), {
      withCredentials: true
    }).pipe(
      map((response) => {
        const histories: PaymentTableHistory[] = response.sales
          .filter(sale => sale.paymentStatus === PaymentStatus.credited)
          .map(sale => ({
            id: sale.saleId,
            date: formatDate(sale.saleDate),
            price: formatPriceAr(sale.totalAmount),
            status: sale.paymentStatus,
            receiptNumber: sale.receiptNumber,
            invoiceNumber: sale.invoiceNumber
          }));

        return {
          histories,
          summary: response.summary
        };
      })
    )
    .subscribe((response) => {
      this.countHistories.set(response.summary.salePaidQty);
      this.listHistories.set(response.histories);
    });
  }

  getListProformas() {
    return this.http.get<ProformasResponse>(buildApiUrl(AppConfig.getProformas), {
      withCredentials: true,
    }).pipe(
      map((response) => {
        const pendings: PaymentTablePending[] = response.bills
          .map(proforma => ({
            id: proforma.id,
            date: formatDate(proforma.createdAt),
            price: this.formatPrice(proforma.totalAmount),
            status: proforma.creditAccountStatus,
            expirationDate: formatDate(proforma.expirationAt),
            pdfUrl: proforma.pdfUrl,
            saleId: proforma.saleId
          }));
        return {
          pendings,
          summary: response.totalCount
        };
      })
    ).subscribe(
      (response) => {
        this.countPending.set(response.summary);
        this.listPending.set(response.pendings);
      }
    );
  }

  postPaymentCreditAccountForm(saleId: number): Observable<string>{
    return this.http.post(buildApiUrl(AppConfig.paymentEpagosCreditAccount(saleId.toString())), {}, {
      responseType: 'text',
      withCredentials:true
    });
  }

  formatPrice(price: number){
    return formatPriceAr(price);
  }

  clear(): void {
    this.listHistories.set(null);
    this.listPending.set(null);
    this.countPending.set(0);
    this.countHistories.set(0);
  }

}
